import { render, staticRenderFns } from "./ContactUsDetail.vue?vue&type=template&id=2a1f0770&"
import script from "./ContactUsDetail.vue?vue&type=script&lang=js&"
export * from "./ContactUsDetail.vue?vue&type=script&lang=js&"
import style0 from "./ContactUsDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports